
import { CONSTANTS } from "../constants";

export default {
  name: "Contact",
  data: () => ({
    HELP_LIST: CONSTANTS.CONTACT_HELP_LIST,
    TESTIMONIAL: CONSTANTS.CONTACT_TESTIMONIAL,
    CONTACT: CONSTANTS.CONTACT_INFO,
    form: {
      name: "",
      companyName: "",
      email: "",
      number: "",
      message: "",
    },
    valueWasEntered: {
      number: false,
      email: false,
      companyName: false,
      message: false,
      name: false,
    },
    inputValidations: {
      email:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      name: /^[a-zA-Z ]+$/,
      number: /^\d{10}$/,
      companyName: /^[a-zA-Z ]+$/,
      message: /^[a-zA-Z ]+$/,
    },
    formSubmitting: false,
    fieldsInvalid: false,
    formSubmitted: false,
  }),
  methods: {
    submitForm() {
      this.formSubmitting = true;
      this.formSubmitted = false;
      if (Object.values(this.inputFieldsValid).every((val) => val === true)) {
        this.fieldsInvalid = false;
        this.$axios
          .post(CONSTANTS.FORMSPREE_ENDPOINT, this.form)
          .then(() => {
            this.form = {
              name: "",
              companyName: "",
              email: "",
              number: "",
              message: "",
            };
            this.isValid = {
              number: "false",
              email: "false",
              companyName: "false",
              message: "false",
              name: "false",
            };
            this.formSubmitted = true;
          })
          .catch((e) => console.log(e));
      } else {
        this.fieldsInvalid = true;
      }
      this.formSubmitting = false;
    },
    valueEntered(key) {
      if (!this.valueWasEntered[key]) this.valueWasEntered[key] = true;
    },
  },
  computed: {
    inputFieldsValid() {
      const validationResult = {};
      for (let key in this.form) {
        validationResult[key] =
          this.form[key].match(this.inputValidations[key]) !== null;
      }
      return validationResult;
    },
  },
  head() {
    return {
      title: "Contact us | AiBuddha",
    };
  },
};
